import { Component, Input, Output, EventEmitter, ElementRef, Renderer, ViewChild } from '@angular/core';
import { Service } from './update-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
var $ = require('jquery');
import { formatDateTimeCustom } from '../../../../../common/utils/utils';

@Component({
  selector: 'update-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./update-restore.scss')],
  template: require('./update-restore.html')
})

export class UpdateRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Input('selectedRestorePoint') selectedRestorePoint;
  @Output('onClose') selfClose = new EventEmitter();
  @ViewChild('datePicker') datePicker:ElementRef;

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private vAppName = "";
  private vdcName = "";
  private restorePointName = "";
  private startTime: any;
  private datePipe = new DatePipe('en-US');
  private isFutureDate: boolean = false;
  private isDateChanged: boolean = false;
  private isDateInitialLoad: boolean = false;
  private isOperationInProgress: boolean = false;

  constructor(public service: Service, private translate: TranslateService, private renderer:Renderer) {
    translate.use(GlobalVariables.LOCALE);
    let start = new Date();
    this.startTime = this.convertJSDateForPicker(start);
  }

  onSubmit() {
    switch(this.mode){
      case DataProtectionVariables.RESTORE_MODES['VAPP']:
        this.updateRestorePointsVapp();
        break;
      case DataProtectionVariables.RESTORE_MODES['DELETED_VAPP']:
        this.updateRestorePointsDeletedVapp();
        break;
      default :
        this.updateRestorePointsVapp();
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedVDC && this.selectedVDC.name && this.selectedObject && this.selectedObject.name && this.selectedRestorePoint && this.selectedRestorePoint.entityName && this.selectedRestorePoint.expiryDate ) {
        this.vAppName = this.selectedObject.name;
        this.vdcName = this.selectedVDC.name;
        this.restorePointName = this.selectedRestorePoint.entityName;
        this.openDatePicker();
        this.startTime = this.convertDateStringForPicker(this.selectedRestorePoint.expiryDate);
        this.isDateInitialLoad = true;
        this.isOperationInProgress  = false;
    }
    else {
      this.isDateInitialLoad = false;
    }
  }

  /**
   * Format from Restore Point grid would be "Fri Apr 29 06:41:47 GMT 2016"
   * Output would be "2016-04-29 06:41:47"
   */
  convertDateStringForPicker(dateString: string) {
    let expiryDate = "";
    let expiryDateArray = dateString.split(" ");
    if (expiryDateArray && expiryDateArray.length == 6) {
      let expiryDateStr = expiryDateArray[0] + " " + expiryDateArray[1] + " " + expiryDateArray[2] + " " + expiryDateArray[3] + " " + expiryDateArray[5];
      expiryDate = this.convertJSDateForPicker(new Date(expiryDateStr), 'y-MM-dd') + " " + expiryDateArray[3];
    }else{
      expiryDate = this.convertJSDateForPicker(new Date(), 'y-MM-dd');
    }
    return expiryDate;
  }
  convertJSDateForPicker(date: Date, format: string = 'y-MM-ddTHH:mm:ss.ms') {
    return this.datePipe.transform(date, format);
  }

  confirmCrossBrowserDate(newDate) {
    let dateObj;
    if ( !isNaN(new Date(newDate).getTime()) ) { //Chrome
      dateObj = new Date(newDate);
    }
    else if ( newDate instanceof Date && !isNaN(newDate.getTime()) ) { //FF
      dateObj = newDate;
    }
    else {
      dateObj = new Date();
    }
    return dateObj;
  }

  onDatePickerChange() {
    let newDateTS;
    newDateTS = this.confirmCrossBrowserDate(this.startTime).getTime();
    this.isFutureDate = newDateTS > new Date().getTime();
    // isDateInitialLoad check is needed because the onDatePickerChange() will be called even before the modal is visible.
    this.isDateChanged = this.isDateInitialLoad;
  }

  ngAfterViewInit() {
  }

  onDatePickerClick(e) {
  }

  openDatePicker() {
    /*let event = new MouseEvent('click', {bubbles: true});
    this.renderer.invokeElementMethod(this.datePicker.nativeElement, 'dispatchEvent', [event]);*/
    this.renderer.invokeElementMethod(this.datePicker.nativeElement, 'click', []);
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  updateRestorePointsVapp() {
    if(this.startTime && this.selectedVDC && this.selectedVDC.id && this.selectedVDC.id !== ''
        && this.selectedObject && this.selectedObject.id && this.selectedObject.id !== ''
        && this.selectedRestorePoint && this.selectedRestorePoint.id && this.selectedRestorePoint.id !== '') {
          this.isOperationInProgress = true;
      this.subscribeHandler = this.service.updateRestorePointsVapp(this.selectedVDC.id, this.selectedObject.id, this.selectedRestorePoint.id,
        this.convertJSDateForPicker( this.confirmCrossBrowserDate(this.startTime), 'y-MM-dd HH:mm:ss') )
          .subscribe(
            res => {
              this.closeSelf();
            },
            error => this.logError(error, 'update restore points for vapp'),
            () => this.logOperationCompleted('update restore points for vapp')
          );
    }
    else
      this.logError('Incorrect VDC or vApp information while deleting restore points for vapp');
  }

  updateRestorePointsDeletedVapp() {
    if(this.startTime && this.selectedVDC && this.selectedVDC.id && this.selectedVDC.id !== ''
        && this.selectedObject && this.selectedObject.id && this.selectedObject.id !== ''
        && this.selectedRestorePoint && this.selectedRestorePoint.id && this.selectedRestorePoint.id !== '') {
          this.isOperationInProgress = true;
      this.subscribeHandler = this.service.updateRestorePointsDeletedVapp(this.selectedVDC.id, this.selectedObject.id, this.selectedRestorePoint.id,
        this.convertJSDateForPicker( this.confirmCrossBrowserDate(this.startTime), 'y-MM-dd HH:mm:ss') )
          .subscribe(
            res => {
              this.closeSelf();
            },
            error => this.logError(error, 'update restore points for deleted vapp'),
            () => this.logOperationCompleted('update restore points for deleted vapp')
          );
    }
    else
      this.logError('Incorrect VDC or vApp information while deleting restore points for deleted vapp');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }


  logError(error, origin:String = '') {
    this.isOperationInProgress = false;
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    this.isOperationInProgress = false;
    console.log('Operation Completed: ', msg)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/update-restore/update-restore.component.ts